export var AccountWarnedType;
(function (AccountWarnedType) {
    AccountWarnedType["RISK_CONTROL"] = "rc";
    AccountWarnedType["FINANCE_MANAGER"] = "fm";
})(AccountWarnedType || (AccountWarnedType = {}));
//# sourceMappingURL=AccountWarnedType.js.map